import jobServices from 'ApiService/Placement/jobServices';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const SelectClass = ({ setDisable, setLoading, classData, setClassData }) => {
  const [errors, setErrors] = useState([]);
  const { state } = useContext(AuthContext);
  const [branch, setBranch] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState('');
  const [loadingBranch, setloadingBranch] = useState(true);
  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [batches, setBatches] = useState([]);
  const navigate = useNavigate();
  const branchId = selectedBranch || state.selectedBranch || null;

  useEffect(() => {
    if (classData.branchId && !selectedBranch) {
      setSelectedBranch(classData.branchId);
    }
  }, [classData, selectedBranch]);

  const handleCourseChange = (event) => {
    const courseId = event.target.value;
    const selectedCourse = courses.find(
      (course) => course.courseId === courseId
    );
    setBatches(selectedCourse?.batches || []);
    setClassData({ ...classData, courseId, batchId: '' });
    // clearData();
  };

  const handleBranchChange = (event) => {
    const branchId = event.target.value;
    console.log(branchId, 'branchId');
    setSelectedBranch(branchId);
    // Store the branch ID in classData to persist it
    setClassData({ ...classData, branchId, courseId: '', batchId: '' });
  };

  const handleBatchChange = (event) => {
    const batchId = event.target.value;
    setClassData({ ...classData, batchId });
  };

  useEffect(() => {
    const newErrors = [];
    if (!classData?.courseId || !classData?.batchId.trim()) {
      newErrors.push('Please fill in all fields.');
    }
    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  }, [classData, setDisable]);

  useEffect(() => {
    if (classData.courseId) {
      const selectedCourse = courses.find(
        (course) => course.courseId === classData.courseId
      );
      setBatches(selectedCourse?.batches || []);
    }
  }, [classData.courseId, courses]);

  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      const response = await jobServices.getCourseBatch(branchId);

      if (response.data.success) {
        setCourses(response?.data?.courses || []);
      } else {
        setCourses([]);
        toast.error('Failed to fetch courses.');
      }
    } catch (error) {
      setCourses([]);
      toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
    } finally {
      setLoadingCourses(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, [branchId]);

  const fetchBranch = async () => {
    setloadingBranch(true);
    try {
      const response = await jobServices.getBranch();
      if (response.data.success) {
        setBranch(response.data.allBranches || []);
      } else {
        toast.error('Failed to fetch Branches.');
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch Branches.'
      );
    } finally {
      setloadingBranch(false);
    }
  };

  useEffect(() => {
    fetchBranch();
  }, []);

  return (
    <div className="w-full rounded-lg px-3 pt-7 md:px-8">
      {/* Header */}
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Select Class Information
        </h4>
      </div>

      {/* Centered Branch Selection */}
      <div className="mt-4 flex justify-center">
        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Branch
          </label>
          <select
            onChange={handleBranchChange}
            value={selectedBranch}
            name="course"
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Branch</option>
            {loadingBranch ? (
              <option>Loading Branch...</option>
            ) : branch.length === 0 ? (
              <option className="cursor-pointer font-bold text-brand-500">
                No Branch available
              </option>
            ) : (
              branch.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.name} ({item.location})
                </option>
              ))
            )}
          </select>
        </div>
      </div>

      {/* Course Select */}
      <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-center md:gap-6">
        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Course
          </label>
          <select
            onChange={handleCourseChange}
            value={classData?.courseId}
            name="course"
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Course</option>

            {loadingCourses ? (
              <option disabled>Loading courses...</option>
            ) : courses.length === 0 ? (
              <option
                disabled
                className="cursor-pointer font-bold text-brand-500"
              >
                No course available or select branch to fetch courses
              </option>
            ) : (
              courses.map((course, i) => (
                <option key={course.courseId} value={course.courseId}>
                  {i + 1}. {course.courseName}
                </option>
              ))
            )}
          </select>
        </div>

        {/* Batch Select */}
        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Batch
          </label>
          <select
            onChange={handleBatchChange}
            value={classData?.batchId}
            name="batch"
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Batch</option>
            {batches.length > 0 ? (
              batches.map((batch) => {
                // Extract unique times from daySchedules
                const times = batch.daySchedules
                  ?.map((ds) => ds.startTime)
                  .filter(Boolean);
                const uniqueTimes = [...new Set(times)]; // remove duplicates
                const timeDisplay =
                  uniqueTimes.length > 0
                    ? ` at ${uniqueTimes.join(' / ')}`
                    : '';

                return (
                  <option key={batch._id} value={batch._id}>
                    B {batch.batchNumber} - From{' '}
                    {new Date(batch.startDate).toLocaleDateString()} {''}
                    to {new Date(batch.endDate).toLocaleDateString()}
                    {timeDisplay}
                  </option>
                );
              })
            ) : (
              <option className="cursor-pointer" value="">
                No batches available
              </option>
            )}
          </select>
        </div>
      </div>

      {/* Display errors */}
      {errors.length > 0 && (
        <div className="text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectClass;
